import React from 'react';

function PageBreak() {
	return(
		<div className="rwxs-m-t-lg rwxs-p-t-lg rwxs-p-t-sm-rsp rwxs-m-t-sm-rsp"></div>
	)
}

export default PageBreak;